import React, { Fragment, useState } from "react";
import { t } from "i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isMobile } from "react-device-detect";
import { isEmpty } from "lodash";
// import babuapp from "../assets/babu888.apk";

const Header = () => {
  const [show, setShow] = useState(true);
  const { type } = useParams();
  const navigate = useNavigate();
  const setLanguageModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLanguageModal;
  });
  const setMenuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setMenuModal;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const location = useLocation();
  let loc = location?.pathname?.split("/")[1];
  const ShowClass = (key) => {
    return `pt-4 pb-2 px-0 page-navigator-button text-capitalize v-btn v-btn--router v-btn--text theme--light v-size--default ${
      key == (type || loc) ? "page-navigator-button--active v-btn--active" : ""
    }`;
  };
  return (
    <Fragment>
      {show && isMobile && (
        <div className="row download-bar no-gutters">
          <button
            onClick={() => setShow(false)}
            type="button"
            style={{ color: "black" }}
            className="v-icon notranslate mr-2 v-icon--link mdi mdi-close theme--light"
          />
          <img
            width={32}
            height={32}
            src="/assets/new/download-app.png"
            alt="download"
            className="mr-2"
          />
          <div className="col">
            <label>{t("DownloadAppBanner")}</label>
          </div>
          <button
            type="button"
            className="download-bar-button subtitle-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
          >
            <span className="v-btn__content"><a href={"#"}  download="babu99" target='_blank' style={{textDecoration:`none`}}>{t("Download")}</a></span>
          </button>
        </div>
      )}
      {isMobile ? (
        <div className="row no-gutters">
          <div className="full-width hidden-md-and-up header-top mobile elevation-3 col col-12">
            <div className="row no-gutters align-center">
              <div className="px-3 col col-12">
                <div className="row no-gutters align-center justify-space-between">
                  <div className="text-left col col-1">
                    <button
                      onClick={() => setMenuModal(true)}
                      type="button"
                      className="v-app-bar__nav-icon v-btn v-btn--icon v-btn--round theme--light v-size--default"
                      height={18}
                      width={22}
                      style={{ height: "18px", width: "22px" }}
                    >
                      <span className="v-btn__content">
                        <i
                          style={{ color: "black" }}
                          aria-hidden="true"
                          className="v-icon notranslate mdi mdi-menu theme--light"
                        />
                      </span>
                    </button>
                  </div>
                  <div className="mobile-header-logo col col-9">
                    <Link
                      to="/"
                      className="router-link-exact-active router-link-active"
                      style={{
                        display: "flex",
                        "-webkit-align-items": "center",
                        "-webkit-box-align": "center",
                        "-ms-flex-align": "center",
                        "align-items": "center",
                      }}
                    >
                      <img
                        src="/assets/new/bb88_logo_animation2.webp"
                        alt
                        width={215}
                        height={45}
                        style={{ "padding-left": "10px" }}
                      />
                    </Link>
                  </div>
                  <div
                    onClick={() => setLanguageModal(true)}
                    className="text-right col col-2"
                  >
                    <button
                      type="button"
                      className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                      style={{
                        width: "55px",
                        cursor: "pointer",
                        backgroundColor: "rgb(218, 218, 218)",
                        paddingLeft: "5px",
                      }}
                    >
                      <span className="v-btn__content">
                        <div
                          className="v-avatar language-button"
                          style={{
                            height: "25px",
                            "min-width": "25px",
                            width: "25px",
                          }}
                        >
                          {
                            localStorage.getItem("language_dir")=="bn-BD" || localStorage.getItem("language_dir")=="en-BD"?
                            <img src="/assets/images/BDT.svg" />:
                             <img src="/assets/images/INR.svg" />

                          }
                          
                        </div>
                        <i
                          style={{ color: "black" }}
                          aria-hidden="true"
                          className="v-icon notranslate mdi mdi-menu-down theme--light"
                        />
                      </span>
                    </button>
                  </div>
                  <div className="spacer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="row hidden-sm-and-down header-top no-gutters align-center justify-space-between">
            <div className="header-column col col-5">
              <Link
                to="/"
                className="router-link-exact-active router-link-active"
              >
                <img
                  src="/assets/new/bb88_logo_animation2.webp"
                  alt
                  width={312}
                  height={58}
                  style={{ float: "left", "padding-left": "32px" }}
                />
              </Link>
            </div>
            <div className="header-column register-dialog text-right col-md-6 col-lg-5 col-5">
              {isEmpty(user) ? (
                <div className="row no-gutters justify-end">
                  <div className="text-right hidden-sm-and-down col col-12">
                    <button
                      onClick={() => navigate("/login")}
                      type="button"
                      className="mr-6 embedded-login-button pa-2 font-weight-bold black--text subtitle-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                      style={{
                        height: "auto",
                        backgroundColor: "rgb(255, 206, 1)",
                        borderColor: "rgb(255, 206, 1)",
                        borderRadius: "8px",
                        fontSize: "14px !important",
                      }}
                    >
                      <span className="v-btn__content">{t("Login")}</span>
                    </button>
                    <button
                      onClick={() => navigate("/register")}
                      data-v-1dea3caa
                      type="button"
                      className="full-width font-weight-bold pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default subtitle-1 full-width font-weight-bold white--text pa-2 embedded-register-button mr-6"
                      style={{
                        backgroundColor: "rgb(0, 128, 246)",
                        borderRadius: "8px",
                        fontSize: "14px !important",
                        color: "white",
                      }}
                    >
                      <span className="v-btn__content">{t("JoinNow")}</span>
                    </button>
                    <button
                      onClick={() => setLanguageModal(true)}
                      type="button"
                      style={{ borderRadius: "10px", background: "#d3d3d3" }}
                      className="pt-0 language_container v-btn v-btn--icon theme--light v-size--small"
                    >
                      <span className="v-btn__content">
                        <div
                          style={{
                            display: "flex",
                            "-webkit-align-items": "center",
                            "-webkit-box-align": "center",
                            "-ms-flex-align": "center",
                            "align-items": "center",
                          }}
                        >
                          <div
                            className="v-avatar language-button"
                            style={{
                              height: "40px",
                              "min-width": "40px",
                              width: "40px",
                            }}
                          >
                            <img src="/assets/images/BDT_new.svg" />
                          </div>
                          <i
                            aria-hidden="true"
                            className="v-icon notranslate largerIcon mdi mdi-menu-down theme--light"
                          />
                        </div>
                      </span>
                    </button>
                  </div>
                  <div className="text-right hidden-md-and-up col col-12">
                    <button
                      onClick={() => navigate("/login")}
                      type="button"
                      className="mr-1 primary-button embedded-mobile-login-button font-weight-bold white--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                      style={{
                        "background-color": "rgb(253, 136, 57)",
                        "border-color": "rgb(253, 136, 57)",
                      }}
                    >
                      <span className="v-btn__content">{t("Login")}</span>
                    </button>
                    <button
                      onClick={() => navigate("/register")}
                      data-v-1dea3caa
                      type="button"
                      className="full-width font-weight-bold pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button embedded-mobile-register-button"
                    >
                      <span className="v-btn__content">{t("Register")}</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="greeting-text font-weight-bold">
                  <label className="greeting-text-btn white--text">
                    {user?.user?.username}
                  </label>
                  <button
                    type="button"
                    className="circle v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  >
                    <span className="v-btn__content">
                      <img
                        src="/assets/images/vector.svg"
                        alt="Vector Image"
                        width={20}
                        height={20}
                      />
                    </span>
                  </button>
                  <hr
                    role="separator"
                    aria-orientation="vertical"
                    thickness={3}
                    color="#D3D3D3"
                    className="v-divider v-divider--vertical theme--light"
                  />
                  <span className="color-base header-wallet v-chip v-chip--clickable v-chip--no-color v-chip--pill theme--light v-size--default">
                    <span className="v-chip__content">
                      <label className="text-capitalize balance black--text">
                        <span>৳ {userCoins?.balance}</span>
                      </label>
                      {/**/}
                    </span>
                  </span>
                  <div
                    onClick={() => navigate("/bank/deposit")}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <button
                      type="button"
                      className="v-icon notranslate color-primary header-wallet-icon v-icon--left v-icon--link material-icons theme--light"
                      style={{
                        "font-size": "50px",
                        color: "rgb(255, 0, 198) !important",
                        "z-index": "1",
                      }}
                    >
                      add_circle
                    </button>
                  </div>
                  <button
                    onClick={() => setLanguageModal(true)}
                    type="button"
                    style={{ borderRadius: "10px" }}
                    className="pt-0 language_container v-btn v-btn--icon  theme--light v-size--small"
                  >
                    <span className="v-btn__content">
                      <div
                        style={{
                          display: "flex",
                          "-webkit-align-items": "center",
                          "-webkit-box-align": "center",
                          "-ms-flex-align": "center",
                          "align-items": "center",
                        }}
                      >
                        <div
                          className="v-avatar language-button"
                          style={{
                            height: "40px",
                            "min-width": "40px",
                            width: "40px",
                          }}
                        >
                          <img src="/assets/images/BDT_new.svg" />
                        </div>
                        <i
                          aria-hidden="true"
                          className="v-icon notranslate mdi mdi-menu-down theme--light"
                        />
                      </div>
                    </span>
                  </button>
                  <button
                    onClick={() => logoutUser()}
                    type="button"
                    className="elevation-0 v-btn v-btn--icon v-btn--round theme--light v-size--small"
                  >
                    <span className="v-btn__content">
                      <img
                        src="/assets/images/logout.svg"
                        alt
                        width={30}
                        height={30}
                        style={{ fill: "rgb(58, 58, 58)" }}
                      />
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="page-navigator hidden-sm-and-down">
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/slot"
                  className={ShowClass("slot")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("SlotGamesNav")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }}>
                {/**/}
              </div>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/casino"
                  className={ShowClass("casino")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("LiveCasinoNav")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }}>
                {/**/}
              </div>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/crash"
                  className={ShowClass("crash")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("Crash")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }}>
                {/**/}
              </div>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/cricket"
                  className={ShowClass("cricket")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("Cricket")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }}>
                {/**/}
              </div>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/table"
                  className={ShowClass("table")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("TableGames")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }} />
            </div>

            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/casino/fishing"
                  className={ShowClass("fishing")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="menu-navigator px-1">
                          {t("Fishing")}
                        </label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  />
                </span>
              </span>
              <div className="v-menu mt-2" style={{ "z-index": "15" }} />
            </div>

            <div className="page-navigator-item">
              <Link
                to="/promotion"
                className={ShowClass("promotion")}
                style={{ height: "auto" }}
              >
                <span className="v-btn__content">
                  <div className="row no-gutters">
                    <div className="pa-0 text-center col col-12">
                      <label className="px-2">{t("Promotion")}</label>
                    </div>
                    <div className="px-0 py-1 underline_bar col col-12">
                      <hr
                        role="separator"
                        aria-orientation="horizontal"
                        className="mx-2 add_border_bold v-divider theme--light"
                      />
                    </div>
                  </div>
                </span>
              </Link>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/refer"
                  className={ShowClass("refer")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="px-2">{t("Referral")}</label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 35px)",
                    }}
                  />
                </span>
              </span>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/vip"
                  className={ShowClass("vip")}
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="px-2">{t("VIP")}</label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 11px)",
                    }}
                  >
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "25px", width: "25px" }}
                    >
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "100%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/game-icon-new.svg")',
                          "background-position": "center center",
                        }}
                      />
                      <div
                        className="v-responsive__content"
                        style={{ width: "35px" }}
                      />
                    </div>
                  </span>
                </span>
              </span>
            </div>

            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/affiliateLink"
                  className="pt-4 pb-2 px-0 page-navigator-button v-btn v-btn--text theme--light v-size--default"
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="px-2">{t("AgentAffiliate")}</label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 35px)",
                    }}
                  >
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "25px", width: "25px" }}
                    >
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "100%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/game-icon-new.svg")',
                          "background-position": "center center",
                        }}
                      />
                      <div
                        className="v-responsive__content"
                        style={{ width: "35px" }}
                      />
                    </div>
                  </span>
                </span>
              </span>
            </div>
            <div className="page-navigator-item">
              <span right className="v-badge v-badge--overlap theme--light">
                <Link
                  to="/reward"
                  className="pt-4 pb-2 px-0 page-navigator-button v-btn v-btn--router v-btn--text theme--light v-size--default"
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="pa-0 text-center col col-12">
                        <label className="px-2">{t("Rewards")}</label>
                      </div>
                      <div className="px-0 py-1 underline_bar col col-12">
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          className="mx-2 add_border_bold v-divider theme--light"
                        />
                      </div>
                    </div>
                  </span>
                </Link>
                <span className="v-badge__wrapper">
                  <span
                    aria-atomic="true"
                    aria-label="Badge"
                    aria-live="polite"
                    role="status"
                    className="v-badge__badge light"
                    style={{
                      inset: "auto auto calc(100% - 4px) calc(100% - 25px)",
                    }}
                  >
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "25px", width: "25px" }}
                    >
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "100%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/game-icon-new.svg")',
                          "background-position": "center center",
                        }}
                      />
                      <div
                        className="v-responsive__content"
                        style={{ width: "35px" }}
                      />
                    </div>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Header;
